import { api } from './../../../system/api';

export default {
	scanPackage: params => api.put(`/inventories/${params.id}/scan-package`, {
		code_package: params.code_package
	}),
	scanTrackingBill: params => api.put(`/inventories/${params.id}/scan-tracking-bill`, params)
};
